import { useEffect, useRef } from 'react';
import { API_BASE_URL } from '../config/api';
import { useNotify } from '../components/ui/notifications/NotificationProvider';

const LOCAL_HOSTS = new Set([
  'localhost',
  '127.0.0.1'
]);

const LOCAL_PORTS = new Set(['8080', '8443', '']);

const isLocalApi = () => {
  try {
    const apiUrl = new URL(API_BASE_URL);
    const hostMatch = LOCAL_HOSTS.has(apiUrl.hostname);
    const port = apiUrl.port || (apiUrl.protocol === 'https:' ? '443' : '80');
    return hostMatch && LOCAL_PORTS.has(port);
  } catch (error) {
    console.warn('[dev-env-check] Unable to parse API_BASE_URL', API_BASE_URL, error);
    return false;
  }
};

const hasProtocolMismatch = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const apiUrl = new URL(API_BASE_URL);
    return window.location.protocol === 'https:' && apiUrl.protocol === 'http:';
  } catch {
    return false;
  }
};

const DevEnvironmentWarning = () => {
  const warnedRef = useRef(false);
  const { notifyWarning } = useNotify();

  useEffect(() => {
    if (!import.meta.env.DEV || warnedRef.current) {
      return;
    }

    if (!isLocalApi()) {
      warnedRef.current = true;
      notifyWarning(
        'VITE_API_URL misconfigured',
        'Local dev should run through the proxy (https://localhost:8080).',
      );
      return;
    }

    if (hasProtocolMismatch()) {
      warnedRef.current = true;
      notifyWarning(
        'Protocol mismatch',
        'App is running over HTTPS but VITE_API_URL uses HTTP. Update VITE_API_URL to https://localhost:8080.',
      );
    }
  }, [notifyWarning]);

  return null;
};

export default DevEnvironmentWarning;
